<script setup lang="ts">
const { reversePosition } = defineProps<IProps>()

const { colors } = useTheme()

interface IProps {
  title: string
  text: string
  btnText: string
  reversePosition?: boolean
  lottieUrl: string
}

const buttonHover = ref(false)
</script>

<template>
  <div
    :flex="reversePosition ? '~ row-reverse <md:col' : '~ row <md:col'" w-full justify-between items-center
  >
    <div pt-7 pb-7 pl-5 pr-5 :style="{ backgroundColor: colors.softGray }" rounded-3 w="45vw <md:full">
      <ClientOnly>
        <LottiePlayerDot
          :src="lottieUrl"
          rounded-3
        />
      </ClientOnly>
    </div>

    <aside flex="~ col" max-w="50% <md:390px" ml="60px <md:0" mr="60px <md:0" justify-center items="start <md:center" mt="<md:40px">
      <div flex items-center mb-24px>
        <IconFilledStar :stroke-color="colors.darkGray" />

        <Heading style="font-family: Circular Std Bold, sans-serif" level="5" :color="colors.darkGray" mr-15px ml-15px>
          {{ title }}
        </Heading>

        <IconFilledStar :stroke-color="colors.darkGray" />
      </div>

      <Heading w="480px <lg:390px <sm:full" text="left <md:center" style="font-family: Circular Std Book, sans-serif; lineHeight: 34px" level="2-light" :color="colors.black">
        {{ text }}
      </Heading>

      <NuxtLink
        :to="LINKS.extension.magicChromeWebStore" target="_blank"
        flex items-center mt-24px @mouseover="buttonHover = true" @mouseleave="buttonHover = false"
      >
        <Heading style="font-family: Circular Std Bold, sans-serif" level="5" :color="buttonHover ? colors.purple : colors.darkPurple">
          {{ btnText }}
        </Heading>

        <IconArrow v-if="!buttonHover" :size="16" background-color="transparent" :stroke-color="colors.darkPurple" style="transform: rotate(90deg)" />
        <IconArrowOnHover v-if="buttonHover" :size="16" background-color="transparent" ml-5px />
      </NuxtLink>
    </aside>
  </div>
</template>
